<!-- components/ShiftCard.vue -->
<template>
    <v-container fluid class="ma-0 pa-0">
        <v-card tile class="mb-4">
            <v-toolbar :color="shift.isSpecific >= 1 ? '#00838f' : 'primary'" dark dense>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" :class="statusIconClass">
                            {{ statusIcon }}
                        </v-icon>
                    </template>
                    <span>
                        Locked by Admin: {{ shift.Finalize ? 'Yes' : 'No' }}
                        <br />
                        Finalized: {{ shift.DispatchFinalize ? 'Yes' : 'No' }}
                        <v-divider />
                        Driver login:
                        {{ formatHumanReadableDateTime(shift.LogStart) }} <br />
                        Driver logout:
                        {{ formatHumanReadableDateTime(shift.LogEnd) }}
                    </span>
                </v-tooltip>
                <v-toolbar-title class="ma-2" style="font-size: medium;">
                    <v-row no-gutters>
                        <v-col align-self="center" class="mr-2">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="text-subtitle-2 font-weight-bold" v-on="on" v-bind="attrs">
                                        <a :href="'/dispatch/shift-assignment#' +
                                            shift.ShiftDetail
                                            " style="text-decoration: none; color:#fff;" target="_blank">
                                            <v-icon small>mdi-identifier</v-icon>
                                            {{ shift.ShiftDetail }}
                                        </a>
                                    </span>
                                </template>
                                Edit in Shift Assignment
                            </v-tooltip>
                            <v-divider />
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="text-subtitle-2 " v-on="on" v-bind="attrs">
                                        <v-icon small left class="mdi-flip-h">mdi-truck-flatbed</v-icon><a :href="'https://my.geotab.com/upt/#map,liveVehicleIds:!(' +
                                            shift.truck.TruckGeotabID +
                                            ')'
                                            " style="text-decoration: none; color:#fff;" target="_blank">
                                            {{ shift.truck.Truck }}
                                        </a>
                                    </span>
                                </template>
                                View Truck in Geotab
                            </v-tooltip>
                        </v-col>
                        <v-col align-self="center" class="">
                            <span class="text-subtitle-2 font-weight-bold">
                                <v-icon small>mdi-account</v-icon>
                                {{ shift.driver.Name }}
                            </span>
                            <v-divider />
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="text-subtitle-2" v-on="on" v-bind="attrs">
                                        <v-icon small left>mdi-train-car-container</v-icon>
                                        {{ shift.trailer.Trailer }}
                                    </span>
                                </template>
                                {{
                                    shift.SpecificProduct == null
                                        ? 'Specific Product: not apply'
                                        : 'Specific Product: ' +
                                        shift.SpecificProduct
                                }}
                            </v-tooltip>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col align-self="center">
                            <span class="text-caption">
                                Start Time: <br />
                                <span style="background-color:#fff; border-radius: 3px; color:#01579b;">
                                    {{
                                        formatHumanReadableDateTime(
                                            shift.ShiftStartTime
                                        )
                                    }}
                                </span>
                            </span>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col align-self="center">
                            <span class="text-caption">Start Yard: <span
                                    :style="shift.GPSShiftStartOrigin == 1 ? 'border-radius: 3px;color:#fff;background-color:#01579b;' : 'border-radius: 3px;color:#fff;background-color:red;'">
                                    {{
                                        shift.GPSShiftStartOrigin == 1
                                            ? shift.ExitTime
                                            : shift.RealExitTime
                                    }}
                                </span> <br />
                                {{ shift.yard.Yard }}

                            </span>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col align-self="center">
                            <span class="text-caption">End Yard: <br />
                                {{
                                    shift?.yardEnd?.Yard || shift.yard.Yard
                                }}</span>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col align-self="center">
                            <span class="text-caption">Shift Hrs: <br />
                                {{ Number(shift.HrsAviable).toFixed(2) }}/{{
                                    shift.TargetHours
                                }}</span>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col v-if="shift.DriverTrainer" align-self="center">
                            <span class="text-caption">
                                Trainer: <br />
                                {{ shift.DriverTrainer }}
                            </span>
                        </v-col>
                        <v-divider vertical class="mx-2" />
                        <v-col>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-badge color="green" class="mt-2" overlap :content="shift.SentMailCounter" :value="shift.SentMailCounter != 0"
                        offset-x="14" offset-y="14">
                        <v-tooltip top>
                            <template v-slot:activator="{
                                on,
                                attrs
                            }">
                                <v-btn @click="
                                    checkOriginOfLoads(
                                        shift,
                                        index
                                    )
                                    " :color="shift.ColorSTDBtn
                                                            " small dark v-bind="attrs" v-on="on">
                                    <v-icon>mdi-send</v-icon>
                                </v-btn>
                            </template>
                            <span>Send To Driver</span>
                        </v-tooltip>
                    </v-badge>
                    
                    <v-menu bottom left offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item v-for="(item, index) in menuItems(shift)" :key="index" @click="item.click">
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="openTracking(shift)">
                                <v-list-item-icon>
                                    <v-icon>mdi-track-light</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                    View Tracking
                                </v-list-item-title>
                            </v-list-item>
                            
                            <v-list-item @click="createPlanB(shift)">
                                <v-list-item-icon>
                                    <v-icon>mdi-alpha-b-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                    Dispatch V3
                                </v-list-item-title>
                            </v-list-item>

                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
            <v-row class="blue-grey lighten-4" no-gutters>
                <v-col cols="1" justify="end">
                    <v-progress-circular v-if="loadProgress" class="my-auto mt-1" indeterminate
                        color="primary"></v-progress-circular>
                </v-col>
                <v-col cols="5">
                    <span class="ml-2 font-weight-bold">Load:</span>
                    <template v-for="badge in shift.driver.badges">
                        <abbr style="text-decoration: none;" :title="badge.TerminalName" v-if="badge.BadgeType == 1">
                            <v-icon class="my-2 ml-1 " :color="badge.Color">mdi-card-bulleted</v-icon>
                        </abbr>
                    </template>
                </v-col>
                <v-col cols="5">
                    <span class="ml-2 font-weight-bold">Unload:</span>
                    <template v-for="badge in shift.driver.badges">
                        <abbr style="text-decoration: none;" :title="badge.TerminalName" v-if="badge.BadgeType == 2">
                            <v-icon class="my-2 ml-1 " :color="badge.Color">mdi-card-bulleted</v-icon>
                        </abbr>
                    </template>
                </v-col>

                <v-col cols="1" justify="end">
                    <v-btn plain style="right: 0;">
                        <v-icon>mdi-chevron-up</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <OrderTable :shiftDetail="shift" :orders="shift.orders" :trailerAxles="shift.trailer.NumAxles || 0"
                @refreshLoads="loadProgress = !loadProgress;" @addOrder="getOrdersByShiftDetail()" />
        </v-card>
        <DriverCurrentShift v-if="dialogs.driverCurrentShift" :value="dialogs.driverCurrentShift"
            :currentShiftData="currentShiftData" @input="dialogs.driverCurrentShift = $event" />
        <TruckCurrentShift v-if="dialogs.truckCurrentShift" :value="dialogs.truckCurrentShift"
            :currentTruckData="currentTruckData" @input="dialogs.truckCurrentShift = $event" />

        <rdTracking v-if="openTraking" :openTraking="openTraking" :params="sdInfo" @close="openTraking = false">
        </rdTracking>
        <ShiftComment v-if="commentDialog" :commentDialog="commentDialog" :shift="shift" @close="commentDialog = false;"
            :commentType="commentType">
        </ShiftComment>
        <lasts v-if="DialogEta" :DialogEta="DialogEta" :Truck="TruckETA" @close="DialogEta = false;"></lasts>
        <ConfirmWindow v-if="confirmWindowDialog" :confirmWindowDialog="confirmWindowDialog" :Title="cwTitle"
            :Message="cwMessage" :ConfirmText="cwConfirmText" :Type="cwType"
            :ShiftDispatchFinalize="shiftDispatchFinalize" @close="onConfirmWindowClose"
            @onlyclose="confirmWindowDialog = false;"></ConfirmWindow>
        <trailerView v-if="canvasDialog" :shift="shift" :canvasDialog="canvasDialog" @close="canvasDialog = false;">
        </trailerView>

        <ShiftSummary v-if="shiftSummaryDialog" :shiftSummaryDialog="shiftSummaryDialog" :ShiftDetail="shiftDetail"
            :EmailCounter="emailCounter" :NewShiftInfo="newShiftInfo" @close="onShiftSummaryClose(shDetail)"
            @onlyClose="shiftSummaryDialog = false;"></ShiftSummary>

        <CurrentShiftForTheTruck v-if="currentShiftForTheTruck" :currentShiftForTheTruck="currentShiftForTheTruck">
        </CurrentShiftForTheTruck>
        <CurrentShiftForTheDriver v-if="currentShiftForTheDriver" :currentShiftForTheDriver="currentShiftForTheDriver"
            @close="currentShiftForTheDriver = false;"></CurrentShiftForTheDriver>
        
            <viewShift
                v-if="openViewC"
                :openViewC="openViewC"
                :data_c="data_c"
                :data_a="data_a"
                :data_l="data_l"
                @close="openViewC = false"
            ></viewShift>
    </v-container>
</template>

<script>
import { dateUtils } from '../../mixins/dateUtils';

import OrderTable from './OrderTable.vue';
import ShiftComment from './ShiftComment.vue';
import lasts from './NewEtaTruck.vue';
import ConfirmWindow from './ConfirmWindow.vue';
import trailerView from './TrailerView.vue';
import ShiftSummary from './ShiftSummary.vue';

import DriverCurrentShift from '../../Modals/Dispatch/Dispatch/DriverCurrentShift.vue';
import TruckCurrentShift from '../../Modals/Dispatch/Dispatch/TruckCurrentShift.vue';
import rdTracking from './../../Modals/Dispatch/Tracking/NewReadGPSTracking.vue';
import CurrentShiftForTheDriver from './CurrentShiftForTheDriver.vue';
import CurrentShiftForTheTruck from './CurrentShiftForTheTruck.vue';
import viewShift from './../../Modals/Dispatch/Dispatch/ReorganizeDispatchV3.vue';
//Modals/Dispatch/Tracking/NewReadGPSTracking.vue';
import axios from 'axios';
export default {
    name: 'ShiftCard',
    components: {
        OrderTable, DriverCurrentShift,
        TruckCurrentShift, rdTracking, ShiftComment,
        lasts, ConfirmWindow, trailerView,
        CurrentShiftForTheDriver, CurrentShiftForTheTruck, ShiftSummary,
        viewShift
    },
    props: ['shift', 'shiftIndex', 'terminals'],
    data() {
        return {
            data_l:null,
            data_a:null,
            data_c:null,
            openViewC:false,
            shiftSummaryDialog: false,
            canvasDialog: false,
            confirmWindowDialog: false,
            shiftDispatchFinalize: null,
            cwTitle: null,
            cwMessage: null,
            cwConfirmText: null,
            cwType: null,
            DialogEta: false,
            TruckETA: null,
            commentType: 'shift',
            commentDialog: false,
            loadProgress: false,
            currentShiftData: [],
            currentTruckData: [],
            currentShiftForTheDriver: false,
            currentShiftForTheTruck: false,
            unknownOrigin: [],
            newShiftInfo: {},
            shiftDetail: null,
            emailCounter: 0,
            openTraking: false,
            sdInfo: null,
            dialogs: {
                driverCurrentShift: false,
                truckCurrentShift: false
            },
            shDetail: null,
        };
    },
    mixins: [dateUtils],
    computed: {
        menuItems(sh) {
            return shift => {
                let items = [];
                items.push({
                    title: 'Refresh',
                    icon: 'mdi-refresh',
                    click: () => this.getOrdersByShiftDetail(),
                    condition: true
                });

                // Shift Comments
                items.push({
                    title: 'Shift Comments',
                    icon:
                        shift.ShiftAssmtComments == null ||
                            shift.ShiftAssmtComments == ''
                            ? 'mdi-comment-off-outline'
                            : 'mdi-comment-eye',
                    click: () => this.openComentDialog(),
                    condition: true // Always true in this case
                });

                // Last ETA List
                // items.push({
                //     title: 'Last ETA List',
                //     icon: 'mdi-clock-time-four',
                //     click: () => this.openLastETA(shift.Truck),
                //     condition: true
                // });

                // See View Traking
                // items.push({
                //     title: 'View Traking',
                //     icon: 'mdi-truck-minus',
                //     click: () => this.openTracking(sh),
                //     condition: true
                // });

                // See Trailer Info
                items.push({
                    title: 'See Trailer Info',
                    icon: 'mdi-eye-outline',
                    click: () => this.chargeModalTrailer(),
                    condition: true
                });

                // Multi-Preload
                // if (shift.Finalize != 1 && shift.DispatchFinalize != 1) {
                //     items.push({
                //         title: 'Multi-Preload',
                //         icon: 'mdi-checkbox-multiple-marked',
                //         click: () => this.multiPreloadOrderActive(),
                //         color: '#4f83cc',
                //         condition: true
                //     });
                // }

                // Forced Completion
                if (
                    shift.Finalize != 1 &&
                    shift.DispatchFinalize != 1 &&
                    shift.DriverEleosApp == 1
                ) {
                    items.push({
                        title: 'Forced Completion',
                        icon: 'mdi-sort-bool-ascending-variant',
                        click: () => this.checkCurrentOrderInProgress(),
                        condition: true
                    });
                }

                // Download Driver Shift Document
                items.push({
                    title: 'Download Driver Shift Document',
                    icon: 'mdi-download-box',
                    click: () => this.getDriverMail(shift),
                    condition: true
                });

                // Close/Open Shift
                if (shift.DriverEleosApp == 1) {
                    if (shift.DispatchFinalize == 0) {
                        items.push({
                            title: 'Close Shift',
                            icon: 'mdi-lock-check',
                            click: () => this.validateShiftCompletion(shift, 'close'),
                            condition: true
                        });
                    } else if (shift.DispatchFinalize == 1) {
                        items.push({
                            title: 'Open Shift',
                            icon: 'mdi-lock-open-check',
                            click: () => this.validateShiftCompletion(shift, 'open'),
                            condition: true
                        });
                    }
                }
                return items;
            };
        },
        statusColor() {
            const orders = this.shift.orders;

            // Check if all orders are finalized but the shift is not
            const allOrdersFinalized = orders.every(
                order => order.Finalize === 1
            );
            if (
                allOrdersFinalized &&
                !this.shift.Finalize &&
                !this.shift.DispatchFinalize
            ) {
                return 'red darken-2';
            }

            // Check if any order has status either INPROGRESS or DONE
            if (
                (orders.some(order => order.OrdLoadStatus === 'INPROGRESS') ||
                    orders.some(order => order.OrdLoadStatus === 'DONE')) &&
                !this.shift.Finalize &&
                !this.shift.DispatchFinalize
            ) {
                return 'blue darken-2';
            }

            // Check if any order has status READYTOSEND
            if (orders.some(order => order.OrdLoadStatus === 'READYTOSEND')) {
                return 'blue-grey darken-1';
            }

            // Default to finalized or pending status for the shift
            return this.shift.Finalize || this.shift.DispatchFinalize
                ? 'green darken-2'
                : 'blue-grey darken-2';
        },
        statusIcon() {
            const orders = this.shift.orders;

            // Check if all orders are finalized but the shift is not
            const allOrdersFinalized = orders.every(
                order => order.Finalize === 1
            );
            if (
                allOrdersFinalized &&
                !this.shift.Finalize &&
                !this.shift.DispatchFinalize
            ) {
                return 'mdi-truck-alert';
            }

            // Check if any order has status INPROGRESS
            if (
                (orders.some(order => order.OrdLoadStatus === 'INPROGRESS') ||
                    orders.some(order => order.OrdLoadStatus === 'DONE')) &&
                !this.shift.Finalize &&
                !this.shift.DispatchFinalize
            ) {
                return 'mdi-truck-fast';
            }

            // Check if any order has status READYTOSEND
            if (orders.some(order => order.OrdLoadStatus === 'READYTOSEND')) {
                return 'mdi-email-alert';
            }

            // Check if shift is finalized
            if (this.shift.Finalize || this.shift.DispatchFinalize) {
                return 'mdi-truck-check';
            }

            // Default to not started
            return 'mdi-timer-sand';
        },
        statusIconClass() {
            const orders = this.shift.orders;

            // Bouncing icon for shifts in progress
            if (orders.some(order => order.OrdLoadStatus === 'INPROGRESS')) {
                return 'bouncing';
            }

            // Pulsing icon for READYTOSEND or shift not finalized but orders are finalized
            if (
                orders.some(order => order.OrdLoadStatus === 'READYTOSEND') ||
                (orders.every(order => order.Finalize === 1) &&
                    !this.shift.Finalize &&
                    !this.shift.DispatchFinalize)
            ) {
                return 'pulsing';
            }

            // No class for finalized shifts
            return '';
        }
    },
    methods: {
        openTracking: function (itm) {
            console.log(itm)
            this.sdInfo = itm;
            this.openTraking = true;
        },
        getBadgeColor(TerminalID) {
            if (!this.terminals) {
                return '';
            } else {
                const terminal = this.terminals.find(
                    t => t.TerminalID == TerminalID
                );
                if (terminal && terminal.Color) {
                    return terminal.Color;
                } else {
                    return '';
                }
            }
        },
        getBadgesByType(driverBadges, type) {
            if (!driverBadges) {
                return [];
            } else {
                return driverBadges.filter(badge => badge.BadgeType == type);
            }
        },
        async checkOriginOfLoads(shift) {
            if (shift.DriverEleosApp == 1) {
                let currShiftData = await this.checkForCurrentShift(
                    shift.driver.DriverID
                );
                console.log(currShiftData);

                if (currShiftData.length != 0) {
                    if (
                        currShiftData[0].DispatchFinalize == 0 &&
                        currShiftData[0].ShiftDetail != shift.ShiftDetail
                    ) {
                        console.log(
                            'Dentro del if, abriendo currentShiftForTheDriver.'
                        );
                        this.currentShiftData = currShiftData;
                        this.dialogs.driverCurrentShift = true;
                        return;
                    } else {
                        console.log('This is the same Shift.');
                    }
                } else {
                    console.error(
                        'No hay ningún Shift actualmente en la tabla EleosCurrentLoadsByDriver.'
                    );
                }

                let currTruckData = await this.checkForCurrentTruck(
                    shift.truck.TruckID
                );
                console.log(currTruckData);

                if (currTruckData.length != 0) {
                    for (let trk of currTruckData) {
                        if (
                            trk.DispatchFinalize == 0 &&
                            trk.ShiftDetail != shift.ShiftDetail
                        ) {
                            console.log(
                                'Dentro del if, abriendo currentShiftForTheTruck.'
                            );
                            this.currentTruckData = trk;
                            this.dialogs.truckCurrentShift = true;
                            return;
                        } else {
                            console.log('This is the same Shift.');
                        }
                    }
                } else {
                    console.log(
                        'No hay ningún Shift con ese Truck actualmente en la tabla EleosCurrentVehicleByDriver.'
                    );
                }

                let shiftDetail = shift.ShiftDetail;
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'tools'
                );
                if (isSynchronized) {
                    await this.checkOriginOfLoadsInterface(shift);
                }
            } else {
                await this.checkOriginOfLoadsInterface(shift);
            }
        },
        async checkForCurrentShift(driverID) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            let shiftData = null;
            await axios
                .get('shift-detail/current-shift/' + driverID)
                .then(response => {
                    console.log(response.data);
                    shiftData = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
            return shiftData;
        },
        async checkForCurrentTruck(truckID) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            let truckData = null;
            await axios
                .get('shift-detail/current-truck/' + truckID)
                .then(response => {
                    console.log(response.data);
                    truckData = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
            return truckData;
        },
        checkSyncPlatforms: async function (fromId, toId, evt) {
            var str = this.$store;

            if (evt !== 'load-shifts') {
                str.state.isLoading = true;
            }

            let params = {
                FromId: fromId,
                ToId: toId
            };

            let syncPlatformsData;
            await axios
                .post('shift-detail/sync-platforms', params)
                .then(response => {
                    console.log(response.data);
                    syncPlatformsData = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
            console.log(syncPlatformsData);

            // Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.
            if (evt == 'load-shifts') {
                console.log(
                    'Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.'
                );
                return;
            }

            if (syncPlatformsData == 'Synchronized') {
                // Things to do depending on the origin of the event
                if (
                    evt == 'view-order' ||
                    evt == 'preload' ||
                    evt == 'un-preload' ||
                    evt == 'split' ||
                    evt == 'un-split' ||
                    evt == 'tools' ||
                    evt == 'itself'
                ) {
                    return true;
                } else if (evt == 'refresh-orders') {
                    await this.getOrdersByShiftDetail('just-refresh');
                }
            } else {
                // Activates the spinner to prevent the dispatcher from making changes
                for (let sh of syncPlatformsData) {
                }

                for (let sh of syncPlatformsData) {
                    await this.getOrdersByShiftDetail('synchronization');
                }

                if (evt == 'itself') {
                    return false;
                }
            }
        },
        async checkOriginOfLoadsInterface(shift) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.unknownOrigin = [];

            let data = {
                OrderIDs: [],
                ShiftDetail: shift.ShiftDetail
            };

            for (let ord of this.shift.orders) {
                data.OrderIDs.push(ord.OrderID);
            }

            // Consult all shift order origins
            let origins = {};
            await axios
                .post('shift-detail/order-origin', data)
                .then(function (response) {
                    //console.log("response->", response.data);
                    origins = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });

            console.log('Origins: ', origins);

            // Set the variable for unknown origins
            let unknownOrigins = {};

            // Finds unknown origins
            for (let ordID in origins) {
                if (origins[ordID].length == 0) {
                    continue;
                } else {
                    unknownOrigins[ordID] = [];
                    for (let origin of origins[ordID]) {
                        if (origin.ShiftDetail == shift.ShiftDetail) {
                            continue;
                        } else {
                            unknownOrigins[ordID].push({
                                ShiftDetail: origin.ShiftDetail,
                                DriverName: origin.DriverName,
                                Date: origin.Date + ' ' + origin.Shift
                            });
                        }
                    }
                }
            }

            // Control to show UnknownOrigins or not
            let showUnknownOrigins = false;

            // Verify and save unknown origins
            for (let ordID in unknownOrigins) {
                if (unknownOrigins[ordID].length == 0) {
                    continue;
                } else {
                    showUnknownOrigins = true;
                    for (let unk of unknownOrigins[ordID]) {
                        this.unknownOrigin.push({
                            OrderID: ordID,
                            ShiftDetail: unk.ShiftDetail,
                            DriverName: unk.DriverName,
                            Date: unk.Date
                        });
                    }
                }
            }

            if (showUnknownOrigins) {
                this.$store.state.dispatch.unknownOrigins = true;
            } else {
                this.confirmShiftSummary(shift);
            }
        },
        confirmShiftSummary: function (shift) {
            console.log('here', shift);
            this.newShiftInfo = {};
            this.shiftDetail = shift.ShiftDetail;
            this.emailCounter = shift.SentMailCounter;
            let sh = {
                Driver: shift.driver?.Name,
                DriverID: shift.driver?.DriverID,
                ShiftDate: shift.shift_header?.Date,
                Shift: shift.shift_header?.Shift,
                ShiftDetail: shift.ShiftDetail,
                Truck: shift.truck?.Truck,
                TruckID: shift.truck?.TruckID,
                Trailer: shift.trailer?.Trailer,
                TrailerID: shift.trailer?.TrailerId,
                ReplacementUnit: shift.ReplacementUnit,
                Yard: shift.yard?.Yard,
                TruckYard: shift.yard?.YardId,
                SentMailCounter: 0,
                DriverEleosApp: shift.DriverEleosApp
            };

            console.log(sh);

            this.newShiftInfo['generalShiftData'] = sh;
            this.newShiftInfo['ordersShiftData'] = [];

            for (let ord of shift.orders) {
                let od = {
                    Customer: ord.customer?.Name,
                    CustomerID: ord.Customer,
                    Supplier: ord.supplier?.Supplier,
                    SupplierID: ord.Supplier,
                    LoadNum: ord.LoadNum,
                    LoadNumOrd: ord.LoadNumOrd,
                    LoadingNumber: ord.LoadingNumber,
                    OrderID: ord.OrderID,
                    OrderStatus: ord.OrderStatus,
                    PreloadOrderID: ord.PreloadOrderID,
                    ShipTo: ord.ShipTo,
                    SpecialInstructions: ord.SpecialInstructions,
                    StationID: ord.Station,
                    Station: ord.StationName,
                    StationAddress: ord.station?.Address,
                    StationCity: ord.StationCity,
                    TerminalID: ord.Terminal,
                    Terminal: ord.TerminalName,
                    TerminalAddress: ord.terminal?.Address,
                    TerminalColor:ord.Color
                };
                console.log('Ord',ord);
                this.newShiftInfo['ordersShiftData'].push({
                    generalOrderData: od,
                    orderProductData: []
                });
            }
            console.log('Prop',this.newShiftInfo);

            this.shiftSummaryDialog = true;
        },
        async getOrdersByShiftDetail(instruction) {
            var str = this.$store;
            this.loadProgress = true;
            /*if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }*/

            if (instruction == 'just-refresh') {
                str.dispatch('setSnackbar', {
                    color: '#1F618D',
                    text: 'Refreshing orders...'
                });

                this.loadProgress = false;
            } else if (instruction == 'synchronization') {
                if (this.shift?.driver?.Name !== '') {
                    this.syncMessage = [
                        `${this.shift.driver.Name}`,
                        ' has progressed in his Shift.',
                        'Your actions will not be executed.',
                        'Try it again after synchronization.',
                        'Synchronizing data with Eleos App...'
                    ];
                    this.$store.state.dispatch.syncWarning = true;
                    this.loadProgress = false;
                }
            }
            await axios
                .post('order/shift/new/' + this.shift.ShiftDetail)
                .then(response => {
                    console.log(response.data);
                    this.shift.orders = response.data;
                    this.loadProgress = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.loadProgress = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something went wrong. Please contact IT Support.'
                    });
                });
        },
        openComentDialog: function () {
            this.commentDialog = true;
        },
        openLastETA: function (Truck) {
            this.TruckETA = Truck;
            this.DialogEta = true;
        },
        getDriverMailInterface: async function ($shift) {
            var str = this.$store;
            str.state.isLoading = true;
            axios({
                url: 'shift-detail/driver-report/' + $shift,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + str.state.token
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'DriversMail.pdf');
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

            console.log(str.state.isLoading);
        },
        getDriverMail: async function ($shift) {
            var str = this.$store;
            let shiftDetail = $shift.ShiftDetail;
            if ($shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'tools'
                );
                if (isSynchronized) {
                    await this.getDriverMailInterface(shiftDetail);
                }
            } else {
                await this.getDriverMailInterface(shiftDetail);
            }
        },
        validateShiftCompletion: async function (shift, action) {
            var str = this.$store;
            /*if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }*/

            let shiftDetail = shift.ShiftDetail;
            let isSynchronized = await this.checkSyncPlatforms(
                shiftDetail,
                'not-apply',
                'tools'
            );
            if (isSynchronized) {
                for (let ord of shift.orders) {
                    if (ord.FinalizeOrder != 1) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This Shift has unfinished orders.'
                        });
                        return;
                    }
                }

                this.shiftDispatchFinalize = shift;
                this.cwTitle = action == 'open' ? 'Open Shift' : 'Close Shift';
                this.cwMessage =
                    'Are you sure you want to ' + action + ' this Shift?';
                this.cwConfirmText =
                    action == 'open' ? 'Open Shift' : 'Close Shift';
                this.cwType = 'dispatchFinalize';
                this.confirmWindowDialog = true;
            }
        },
        onConfirmWindowClose: function (type, shiftDetail, status) {
            // let index = this.shiftDetails.indexOf(shiftDetail);
            this.confirmWindow = false;
            switch (type) {
                case 'dispatchFinalize':
                    //let shiftData = await this.getSpecificShift(shDetail, index);
                    // Update DispatchFinalize locally
                    this.shifts.DispatchFinalize = status;
                    //this.loadShifts(true);
                    break;
                default:
                    console.log('No event on close.');
            }
        },
        chargeModalTrailer() {
            this.canvasDialog = true;
        },
        buildNewShiftInfoDispatch: function (shDetail, index) {
            console.log(shDetail, index);
            let newShiftInfoDispatch = {};
            let shift = this.shifts[index];

            // Preparation of the new shift info data
            let {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            } = shift;

            let generalShiftData = {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            };

            console.log(shift);
            console.log(generalShiftData);

            newShiftInfoDispatch['generalShiftData'] = generalShiftData;
            newShiftInfoDispatch['ordersShiftData'] = [];

            for (let ord of this.shiftOrders[index]) {
                let {
                    Customer,
                    CustomerID,
                    Supplier,
                    SupplierID,
                    LoadNum,
                    LoadNumOrd,
                    LoadingNumber,
                    OrderID,
                    OrderStatus,
                    PreloadOrderID,
                    ShipTo,
                    SpecialInstructions,
                    StationID,
                    Station,
                    StationAddress,
                    StationCity,
                    TerminalID,
                    Terminal,
                    TerminalAddress,
                    TerminalColor
                } = ord;

                newShiftInfoDispatch['ordersShiftData'].push({
                    generalOrderData: {
                        Customer,
                        CustomerID,
                        Supplier,
                        SupplierID,
                        LoadNum,
                        LoadNumOrd,
                        LoadingNumber,
                        OrderID,
                        OrderStatus,
                        PreloadOrderID,
                        ShipTo,
                        SpecialInstructions,
                        StationID,
                        Station,
                        StationAddress,
                        StationCity,
                        TerminalID,
                        Terminal,
                        TerminalAddress,
                        TerminalColor
                    },
                    orderProductData: []
                });
            }

            return newShiftInfoDispatch;
        },
        onShiftSummaryClose: async function (shDetail) {
            console.log('Close Shift Summary', shDetail);
            let index = this.shiftDetails.indexOf(shDetail);
            this.setTrackingHours(shDetail);
            await this.loadOrderShift(shDetail, index, 'onShiftSummaryClose');
            // Update SentMailCounter locally
            let shiftData = await this.getSpecificShift(shDetail, index);
            this.shifts[index].SentMailCounter = shiftData.SentMailCounter;
            this.shifts[index].ColorSTDBtn = '#4f83cc';

            //this.loadShifts(true);
        },
        createPlanB: function (shift){
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/by/shift/' + shift.ShiftDetail +'/' + this.$store.state.shiftId.ShiftId)
                .then(response => {
                    this.data_c = response.data.shifts;
                    this.data_a = response.data.actual;
                    this.data_l = response.data.lineup;
                    console.log(response.data);
                    str.state.isLoading = false;
                    this.openViewC = true;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}
</style>
